import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  content: {
    alignItems: 'center',
  },
  liveANFTitleText: {
    marginBottom: Theme.px(46),
    textAlign: 'center',
    width: Theme.px(428),
  },
  watchButton: {
    marginBottom: Theme.px(15),
  },
});
